var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Chara'),_c('Header'),_c('Main'),_c('Footer'),_c('Loading'),_c('ThemeEditor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }